const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});
export const LOAD_GROUP = asyncActionType('LOAD_GROUP');
export const ADD_GROUP = asyncActionType('ADD_GROUP');
export const DELETE_GROUP=asyncActionType('DELETE_GROUP');
export const UPDATE_GROUP = asyncActionType('UPDATE_GROUP');

export const LOAD_RENTAL = asyncActionType('LOAD_RENTAL');
export const ADD_RENTAL=asyncActionType('ADD_RENTAL');
export const DELETE_RENTAL=asyncActionType('DELETE_RENTAL');
export const EDIT_RENTAL = asyncActionType('EDIT_RENTAL');

export const CLEAR_RENTAL_ADD='CLEAR_RENTAL_ADD';
export const UPDATE_RENTAL_DATA_INHERITED='UPDATE_RENTAL_DATA_INHERITED';

export const LOAD_PROPERTY=asyncActionType('LOAD_PROPERTY');
export const ADD_PROPERTY=asyncActionType('ADD_PROPERTY');
export const DELETE_PROPERTY=asyncActionType('DELETE_PROPERTY');
export const EDIT_PROPERTY = asyncActionType('EDIT_PROPERTY');
export const GET_COORDINATES = asyncActionType('GET_COORDINATES');
export const CLEAR_COORDINATES = 'CLEAR_COORDINATES';

